import { useMemo } from 'react';
import type { AppState } from '@/lib/types';
import { calcTrainingInsights } from '@/lib/analytics';
import { getExerciseCategory } from '@/lib/exercise-library';

export function useInsights(state: AppState) {
  return useMemo(
    () => calcTrainingInsights(
      state.history,
      { scheduleType: state.scheduleType, weeklySchedule: state.weeklySchedule, cadenceSchedule: state.cadenceSchedule },
      (name: string) => getExerciseCategory(name, state.customExCatMap)
    ),
    [state.history, state.scheduleType, state.weeklySchedule, state.cadenceSchedule, state.customExCatMap]
  );
}
